// extracted by mini-css-extract-plugin
module.exports = {"icon":"search_icon__TOKGp","input":"search_input__2sltG","searchIcon":"search_searchIcon__3RuMV"};